export default __webpack_public_path__ + "static/media/emptycart.8aa1ea62.png";